import { db } from "../utils/firebase";
import {
  collection,
  getDocs,
  query,
  where,
  doc,
  getDoc,
} from "firebase/firestore";
import { useState, useEffect } from "react";
import { uuidv4 as uuid } from "@firebase/util";
import { useParams, Link, useNavigate } from "react-router-dom";
import UserInfoModal from "../components/UserInfoModal";
import { GetUsers } from "../functions/GetUsers";
import UserListing from "../components/UserListing";

const Members = () => {
  const { community } = useParams();
  const navigate = useNavigate();

  const [queryState, setQueryState] = useState({
    isLoading: true,
    errorMessage: "",
    docSnapshots: null,
  });

  useEffect(() => {
    async function loader() {
      try {
        setQueryState({
          isLoading: true,
          errorMessage: "",
          docSnapshots: null,
        });
        const querySnapshot = await getDocs(collection(db, "Users"));
        const docs = querySnapshot.docs;
        setQueryState({
          isLoading: false,
          errorMessage: "",
          docSnapshots: docs,
        });
      } catch (error) {
        setQueryState({
          isLoading: false,
          errorMessage: "Error",
          docSnapshots: null,
        });
        console.log(error);
      }
    }

    loader();

    async function getUserLevel() {
      const docRef = doc(db, "Users", localStorage.getItem("id"));
      const docSnap = await getDoc(docRef);

      if (docSnap.data().userTypeNumber < 3) {
        navigate(-1);
      }
    }

    getUserLevel();
  }, []);

  const { isLoading, errorMessage, docSnapshots } = queryState;

  let content;

  if (isLoading) {
    content = (
      <div
        className="spinner-border text-primary text-center justify-center mx-auto flex bg-user-home"
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    );
  } else if (errorMessage) {
    content = errorMessage;
  } else {
    content = (
      <UserListing data={docSnapshots} level={4} community={community} />
    );
  }

  return (
    <>
      <div key={uuid} style={{ maxWidth: "90%", margin: "0 auto" }}>
        {content}
      </div>
    </>
  );
};

export default Members;
